import { Navigate, useLocation, useNavigate } from "react-router";
// import { useAuth } from "./authContext";
import { LOCAL_STORAGE_KEYS, ROUTES } from "../helpers/constants";
import SidebarWrapper from "../common_components/SIdebarWrapper";
import { useEffect } from "react";
import { useAuth } from "./authContext";
import { MethodType, useApi } from "../helpers/apiClient";
import Loader from "../common_components/Loader";

export default function ProtectedRouteProvider(props) {
    const { user, setUser } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const getToken = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);

    const { callApi, loading } = useApi()




    useEffect(() => {
        let token = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
        if (user.isLoggedIn === false && token) {
            fetchUserInfo();
        } else if (user.isLoggedIn === true && token) {
            setUser({ ...user, isLoading: false });
        } else {
            setUser({ ...user, isLoading: false });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const fetchUserInfo = async () => {
        try {
            let response = await callApi(MethodType.GET, `/admin/auth/me`)
            setUser({ isLoggedIn: true, data: response.data.user, isLoading: false });
        } catch (error) {
            setUser({ isLoggedIn: false, isLoading: false, data: null });
            localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
            navigate(ROUTES.MAIN, { replace: true });
        }
    }
    if (user.isLoading) {
        return <Loader />;
    }

    if (process.env.NODE_ENV === 'development') {
        console.log(user);
    }

    if (user.isLoggedIn) {
        return <SidebarWrapper>{props.children}</SidebarWrapper>
    } else {
        return <Navigate to={'/'} />
    }
}
